import React from "react";
import PropTypes from "prop-types";
import { makeStyles, createStyles } from "@material-ui/core";
import UserPreferencesComponent from "../Components/UserPreferences/UserPreferencesComponent";
import CreateReport from "../Components/CreateReport/CreateReport";

const useStyles = makeStyles((theme) =>
  createStyles({
    userPreferencesViewContainer: {
      position: "absolute",
      left: "0",
      right: "0",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
  })
);

const UserPreferencesView = ({ createReportOpen, setCreateReportOpen, match, googleScriptLoaded }) => {
  const classes = useStyles();
  const user = match.params.user;
  return (
    <div className={classes.userPreferencesViewContainer}>
      {createReportOpen.open && <CreateReport googleScriptLoaded={googleScriptLoaded} createReportOpen={createReportOpen} setCreateReportOpen={(status) => setCreateReportOpen(status)} />}
      <UserPreferencesComponent user={user} />
    </div>
  );
};

UserPreferencesView.propTypes = {
  createReportOpen: PropTypes.object,
  setCreateReportOpen: PropTypes.func,
  match: PropTypes.object,
  googleScriptLoaded: PropTypes.bool,
};

export default UserPreferencesView;
